module.exports = "../../static/img/review_3.178ee48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reviews/review_3.jpg
// module id = cHvc
// module chunks = 1